<div class="row">
    <div class="col-auto">
        <div class="input-group input-group-sm">
            <input type="text" class="form-control" placeholder="검색어"
                [(ngModel)]="searchValue"
                (keyup.enter)="keyupEnterSearchValue($event)">
            <div class="input-group-append">
                <button type="button" class="btn btn-outline-secondary"
                    (click)="clickSearch()">
                    <i class="fas fa-search"></i>
                    <span class="ml-1">
                        검색
                    </span>
                </button>
            </div>
        </div>
    </div>
    <div class="col"></div>
    <div class="col-auto">
        <button type="button" class="btn btn-sm btn-outline-secondary"
            (click)="clickOpenModalNoticeInfo(DtgActionType.create,null)">
            <i class="mdi mdi-plus"></i>
            <span class="ml-1">
                공지추가
            </span>
        </button>
    </div>
</div>

<div class="mt-3">
    <table class="table table-sm table-hover align-items-center mb-0" style="table-layout: fixed;">
        <thead>
            <tr>
                <th style="width: 80px;">
                    공지유형
                </th>
                <th>
                    제목
                </th>
                <th style="width: 60px;">
                    팝업여부
                </th>
                <th style="width: 160px;">
                    팝업기간
                </th>
                <th style="width: 140px;">
                    등록일시
                </th>
                <th style="width: 70px;" [hidden]="listType === DtgListType.modal">
                    편집
                </th>
            </tr>
        </thead>
        <tbody class="">
            <tr *ngFor="let item of listNotice;">
                <td>
                    {{item.noticeType}}
                </td>
                <td class="text-truncate">
                    <div class="btn btn-sm btn-link px-0 text-info text-truncate"
                        role="button"
                        (click)="clickOpenModalNoticeInfo(DtgActionType.read,item)">
                        {{item.title}}
                    </div>
                </td>
                <td>
                    {{item.popupYn}}
                </td>
                <td>
                    <span [hidden]="!item.popupDtFrom">
                        {{item.popupDtFrom}}
                    </span>
                    <br [hidden]="!item.popupDtTo">
                    <span [hidden]="!item.popupDtTo">
                        ~ {{item.popupDtTo}}
                    </span>
                </td>
                <td>
                    {{item.updateDt}}
                </td>
                <td [hidden]="listType === DtgListType.modal">
                    <button type="button"
                        class="btn btn-sm btn-outline-secondary"
                        (click)="clickOpenModalNoticeInfo(DtgActionType.update,item)">
                        <i class="mdi mdi-pen"></i>
                        <span class="ml-1">
                            수정
                        </span>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<div class="mt-3">
    <list-paging
        [inputPagingInfo]="pagingInfo"
        (callbackClickPageNumber)="callbackClickPageNumber($event)"
        (callbackChangeCountRowPerPage)="callbackChangeCountRowPerPage($event)"></list-paging>
</div>